// Location landing pages — imported from the old WebsiteBaker site (SQL dump).
//
// IMPORTANT for SEO retention: `slug` MUST match the old site's URL exactly,
// e.g. the old page /lej-en-polsevogn-kobenhavn/ must stay at that same path.
// Titles/descriptions are carried over verbatim from the old `wb_pages` table.
//
// `keywords` is legacy data (Google ignores meta keywords) — kept for reference
// and possible internal-linking work. It is NOT rendered into the page.

export const LOCATIONS = [
  {
    slug: "lej-polsevogn-arhus",
    title: "Lej Pølsevogn Århus",
    description:
      "Vi udlejer vores pølsevogn i Århus til alle festlige formål fra 10 til 10000 mennesker",
    keywords: ["Pølsevogn", "Pølsemand", "Århus", "Leje", "Lej en Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-kolding",
    title: "Lej en Pølsevogn Kolding",
    description: "Vi udlejer vores pølsevogn i Kolding til alle formål.",
    keywords: ["Pølsevogn", "Pølsemand", "Kolding", "Lej Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-vejle",
    title: "Lej en Pølsevogn Vejle",
    description: "Vi udlejer vores pølsevogn i vejle til alle typer arrangementer",
    keywords: ["Pølsevogn Leje", "Vejle", "Pølsemand", "Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-fredericia",
    title: "Lej en Pølsevogn Fredericia",
    description:
      "Vi udlejer vores pølsevogn i Fredericia til alle sjove og festlige lejligheder",
    keywords: ["Pølsevogn", "leje af Pølsevogn", "Fredericia", "Pølsemand Fredericia"],
  },
  {
    slug: "lej-en-polsevogn-odense",
    title: "Lej en Pølsevogn Odense",
    description:
      "Vi udlejer vores pølsevogn til alle formål i Odense. Store som mindre arrangementer.",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Odense"],
  },
  {
    slug: "lej-en-polsevogn-kobenhavn",
    title: "Lej en Pølsevogn København",
    description: "Udlejning af pølsevogn i København til alle festlige formål",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn København"],
  },
  {
    slug: "lej-en-polsevogn-tastrup",
    title: "Lej en Pølsevogn Tåstrup",
    description:
      "Vi udlejer vores pølsevogn i Tåstrup til alle festlige formål fra 10 til 10000 mennesker",
    keywords: ["Pølsevogn", "Pølsemand", "Tåstrup", "Leje", "Lej en Pølsevogn", "Taastrup"],
  },
  {
    slug: "lej-en-polsevogn-ballerup",
    title: "Lej en Pølsevogn Ballerup",
    description:
      "Vi udlejer vores pølsevogn i Ballerup til alle festlige formål fra 10 til 10000 mennesker",
    keywords: ["Pølsevogn", "Pølsemand", "Ballerup", "Leje", "Lej en Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-herlev",
    title: "Lej en Pølsevogn Herlev",
    description:
      "Vi udlejer vores pølsevogn i Herlev til alle festlige formål fra 10 til 10000 mennesker",
    keywords: ["Pølsevogn", "Pølsemand", "Herlev", "Leje", "Lej en Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-glostrup",
    title: "Lej en Pølsevogn Glostrup",
    description: "Vi udlejer vores pølsevogn i Glostrup til alle formål.",
    keywords: ["Pølsevogn", "Pølsemand", "Glostrup", "Lej Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-albertslund",
    title: "Lej en Pølsevogn Albertslund",
    description: "Vi udlejer vores pølsevogn i Albertslund til alle festlige formål",
    keywords: ["Pølsevogn", "Leje af Pølsevogn", "Albertslund", "Pølsemand", "Lej"],
  },
  {
    slug: "lej-en-polsevogn-roskilde",
    title: "Lej en Pølsevogn Roskilde",
    description: "Vi udlejer vores pølsevogn i Roskilde til alle formål.",
    keywords: ["Pølsevogn", "Pølsemand", "Roskilde", "Lej Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-avedore",
    title: "Lej en Pølsevogn Avedøre",
    description: "Vi udlejer vores pølsevogn i Avedøre til alle formål.",
    keywords: ["Pølsevogn", "Pølsemand", "Avedøre", "Lej Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-ishoj",
    title: "Lej en Pølsevogn Ishøj",
    description: "Vi udlejer vores pølsevogn i Ishøj til alle formål.",
    keywords: ["Pølsevogn", "Pølsemand", "Ishøj", "Lej Pølsevogn"],
  },
  {
    slug: "lej-en-polsevogn-frederiksvaerk",
    title: "Lej en Pølsevogn Frederiksværk",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Frederiksværk. Store som mindre arrangementer.",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Frederiksværk"],
  },
  {
    slug: "lej-en-polsevogn-horsens",
    title: "Lej en Pølsevogn Horsens",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Horsens. Store som mindre arrangementer.",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Horsens"],
  },
  {
    slug: "lej-en-polsevogn-randers",
    title: "Lej en Pølsevogn Randers",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Randers og omegn. Store som mindre arrangementer.",
    keywords: ["Lej en pølsevogn Randers", "Pølsemand", "Pølsevogn", "Leje Randers"],
  },
  {
    slug: "lej-en-polsevogn-nordsjaelland",
    title: "Lej en Pølsevogn Nordsjælland",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i hele Nordsjælland. Store som mindre arrangementer for privat og erhvev",
    keywords: ["Lej pølsevogn Nordsjælland", "Leje", "Pølsevogn", "Nordsjælland"],
  },
  {
    slug: "lej-en-polsevogn-naestved",
    title: "Lej en Pølsevogn Næstved",
    description: "Lej vores pølsevogn i Næstved til dit næste arrangement.",
    keywords: ["Leje pølsevogn Næstved", "Pølsemand", "Pølsevogn", "Næstved", "Leje", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-hillerod",
    title: "Lej en Pølsevogn Hillerød",
    description:
      "Vi udlejer vores pølsevogn til alle formål i Hilllerød. Store som mindre arrangementer.",
    keywords: ["Pølsevogn leje Hillerød", "Pølsemand", "Pølsevogn", "Leje", "Hillerød"],
  },
  {
    slug: "lej-en-polsevogn-helsingor",
    title: "Lej en Pølsevogn Helsingør",
    description:
      "Lej vores pølsevogn i Helsingør næste gang du skal bruge et sjovt og utraditionelt indslag.",
    keywords: ["Lej pølsevogn Helsingør", "Pølsevogn", "Leje", "Helsingør"],
  },
  {
    slug: "lej-en-polsevogn-ringsted",
    title: "Lej en Pølsevogn Ringsted",
    description:
      "Lej vores pølsevogn i Ringsted til alle typer og størrelser af arrangementer i Ringsted.",
    keywords: ["lej pølsevogn Ringsted", "Pølsevogn", "Pølsemand", "Leje", "Ringsted"],
  },
  {
    slug: "lej-en-polsevogn-viborg",
    title: "Lej en Pølsevogn Viborg",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Viborg. Store som mindre arrangementer.",
    keywords: ["Leje", "Pølsevogn", "Viborg", "Udlejning", "Pølsemand", "Lej pølsevogn Viborg"],
  },
  {
    slug: "lej-en-polsevogn-herning",
    title: "Lej en Pølsevogn Herning",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Herning. Store som mindre arrangementer.",
    keywords: ["Pølsevogn", "Herning", "Udlejning", "Leje", "Lej pølsevogn Herning", "Pølsemand"],
  },
  {
    slug: "lej-en-polsevogn-grenaa",
    title: "Lej en Pølsevogn Grenaa",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Grenaa. Store som mindre arrangementer.",
    keywords: ["Leje", "Pølsevogn", "Lej", "Udlejning", "Pølsemand", "Pølsevogn natmad", "Lej en pølsevogn Grenaa"],
  },
  {
    slug: "lej-en-polsevogn-ikast",
    title: "Lej en Pølsevogn Ikast",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Ikast. Store som mindre arrangementer.",
    keywords: ["Leje", "Pølsevogn", "Udlejning", "Lej Pølsevogn Ikast"],
  },
  {
    slug: "lej-en-polsevogn-esbjerg",
    title: "Lej en Pølsevogn Esbjerg",
    description:
      "Vi udlejer vores pølsevogn ud til alle formål i Esbjerg. Store som mindre arrangementer.",
    keywords: ["Leje", "Pølsevogn", "Pølsemand", "lej", "Udlejning", "Lej pølsevogn Esbjerg"],
  },
  {
    slug: "lej-en-polsevogn-brondby",
    title: "Lej en Pølsevogn Brøndby",
    description: "Vi udlejer vores pølsevogn i Brøndby til alle festlige lejligheder",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "Brøndby"],
  },
  {
    slug: "lej-en-polsevogn-gentofte",
    title: "Lej en pølsevogn Gentofte",
    description:
      "Lej vores pølsevogn til dit arrangement i Gentofte og omegn. Vi garanterer den autentiske oplevelse",
    keywords: ["Pølsevogn", "leje", "Gentofte", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-holbaek",
    title: "Lej en Pølsevogn Holbæk",
    description:
      "Vi udlejer vores pølsevogn i Holbæk til private og erhverv til alle typer arrangementer",
    keywords: ["Pølsevogn", "Pølsemand", "leje", "udlejning", "Holbæk", "Lej"],
  },
  {
    slug: "lej-en-polsevogn-gladsaxe",
    title: "Lej en Pølsevogn Gladsaxe",
    description: "Lej vores pølsevogn til din næste fest i Gladsaxe",
    keywords: ["Pølsevogn", "Gladsaxe", "Leje", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-soborg",
    title: "Lej en Pølsevogn Søborg",
    description: "Få besøg af pølsevogn næste gang du skal have fest i Søborg",
    keywords: ["Lej", "Pølsevogn", "Pølsemand", "Leje", "Udlejning", "Søborg"],
  },
  {
    slug: "lej-en-polsevogn-kastrup",
    title: "Lej en Pølsevogn Kastrup",
    description:
      "Skal du bruge en pølsevogn til din fest i Kastrup. Så kontakt os for et godt tilbud.",
    keywords: ["Pølsevogn", "Leje", "Kastrup", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-rodovre",
    title: "Lej en Pølsevogn Rødovre",
    description: "Få besøg af din lokale pølsevogn i Rødovre",
    keywords: ["Pølsevogn", "Pølsemand", "Leje", "Rødovre", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-slagelse",
    title: "Lej en Pølsevogn Slagelse",
    description: "Lej vores pølsevogn i Slagelse til din næste fest",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Slagelse"],
  },
  {
    slug: "lej-en-polsevogn-amager",
    title: "Lej en Pølsevogn Amager",
    description:
      "Vi udlejer vores pølsevogn til alle festlige begivenheder på Amager. Vi er en perfekt løsning til natmad",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Amager"],
  },
  {
    slug: "lej-en-polsevogn-nykobing-sj",
    title: "Lej en Pølsevogn Nykøbing Sj",
    description:
      "Vi lejer vores pølsevogn ud til alle formål fra 30 til 10000 personer i hele Nykøbing S",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Nykøbing Sjælland"],
  },
  {
    slug: "lej-en-polsevogn-vordingborg",
    title: "Lej en Pølsevogn Vordingborg",
    description: "Vi lejer vores pølsevogn ud med servering i Vordingborg",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Vordingborg"],
  },
  {
    slug: "lej-en-polsevogn-mon",
    title: "Lej en Pølsevogn Møn",
    description: "Vi lejer vores pølsevogn ud til alle festlige begivenheder på hele Møn.",
    keywords: ["Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Møn", "Stege"],
  },
  {
    slug: "lej-en-polsevogn-lolland",
    title: "Lej en Pølsevogn Lolland",
    description: "Lej vores pølsevogn til dit næste festlige arrangement på Lolland.",
    keywords: [
      "Pølsemand", "Pølsevogn", "Leje", "udlejning", "Lej en pølsevogn Lolland",
      "Maribo", "Nakskov", "Marienlyst", "Rødby",
    ],
  },
  {
    slug: "lej-en-polsevogn-greve-og-solrod",
    title: "Lej en Pølsevogn Greve og Solrød",
    description: "Lej vores pølsevogn i Greve og Solrød til alle festlige begivenheder",
    keywords: ["Pølsevogn", "Leje", "Greve", "Solrød", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-frederikssund",
    title: "Lej en Pølsevogn Frederikssund",
    description:
      "Lej vores pølsevogn i Frederikssund til alle typer arrangementer med garanti for alle blive mætte og glade",
    keywords: ["Pølsevogn", "Lej", "Pølsemand", "Frederikssund", "Udlejning", "Catering", "natmand", "Diner transportable"],
  },
  {
    slug: "lej-en-polsevogn-koge",
    title: "Lej en Pølsevogn Køge",
    description:
      "Lej vores pølsevogn til alle typer begivenheder og events i Køge. Fra 30 til 10000 personer alle bliver med garanti mætte og glade.",
    keywords: ["Leje", "Pølsevogn", "Køge", "Pølsemand", "Udlejning", "Catering", "Diner transportale"],
  },
  {
    slug: "lej-en-polsevogn-silkeborg",
    title: "Lej en Pølsevogn Silkeborg",
    description: "Vi lejer vores pølsevogn ud til alle festlige lejligheder i Silkeborg og omegn.",
    keywords: ["Pølsevogn", "Leje", "Silkeborg", "Udlejning", "Catering", "Natmad", "Pølsemand"],
  },
  {
    slug: "lej-en-polsevogn-horsholm",
    title: "Lej en Pølsevogn Hørsholm",
    description: "Lej vores pølsevogn til dit festlige arrangement i Hørsholm.",
    keywords: ["Pølsevogn", "Leje", "Hørsholm", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-olstykkestenlose",
    title: "Lej en Pølsevogn Ølstykke/Stenløse",
    description: "Få besøg af vores pølsevogn til din næste fest i Ølstykke eller Stenløse",
    keywords: ["Pølsevogn", "Leje", "Ølstykke", "Stenløse", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-nyborg",
    title: "Lej en Pølsevogn Nyborg",
    description: "Lej vores lokale pølsevogn i Nyborg til dit næste festlige arrangement.",
    keywords: ["Pølsevogn", "Leje", "Nyborg", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-kalundborg",
    title: "Lej en Pølsevogn Kalundborg",
    description:
      "Få besøg af vores pølsevogn til jeres næste festlige arrangement i Kalundborg. Fra 10 til 10000 personer.",
    keywords: ["Pølsevogn", "Leje", "Kalundborg", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-middelfart",
    title: "Lej en Pølsevogn Middelfart",
    description: "Lej vores pølsevogn til din næste festlige begivenhed i Middelfart",
    keywords: ["Pølsevogn", "Leje", "Middelfart", "Pølsemand", "Udlejning"],
  },
  {
    slug: "lej-en-polsevogn-brande",
    title: "Lej en Pølsevogn Brande",
    description: "Lej vores pølsevogn til alle typer festlige lejligheder i Brande og omegn.",
    keywords: ["Pølsevogn", "Brande", "leje", "udlejning", "Pølsemand"],
  },
  {
    slug: "lej-en-polsevogn-langeland",
    title: "Lej en Pølsevogn Langeland",
    description: "Vi udlejer vores pølsevogn til alle typer arrangementer på hele Langeland",
    keywords: ["Pølsevogn", "Leje", "Udlejning", "Pølsemand", "Langeland", "Tåsinge"],
  },
  {
    slug: "lej-polsevogn-als",
    title: "Lej Pølsevogn Als",
    description: "Lej vores pølsevogn til din næste fest på Als.",
    keywords: ["Pølsevogn", "leje", "Als", "Udlejning", "Pølsemand"],
  },
  {
    slug: "lej-en-polsevogn-odsherred",
    title: "Lej en Pølsevogn Odsherred",
    description: "Lej vores pølsevogn til din næste festlige begivenhed i Odsherred",
    keywords: [
      "Pølsevogn", "Leje", "Udlejning", "Pølsemand", "Lej", "Odsherred", "Rørvig",
      "Asnæs", "Fårevejle", "Nykøbing S", "Højby", "Grevinge", "Vig Sjællands Odde", "Lumsås",
    ],
  },
  {
    slug: "lej-en-polsevogn-djursland",
    title: "Lej en Pølsevogn Djursland",
    description:
      "Vi udlejer vores pølsevogn på hele Djursland til alle begivenheder fra 10 til 10000 personer",
    keywords: [
      "Pølsevogn", "Leje", "Udlejning", "Lej", "Pølsemand", "Grenaa",
      "Ebeltoft", "Rønde", "Hornslet", "Auning",
    ],
  },
  {
    slug: "lej-en-polsevogn-hornsherred",
    title: "Lej en Pølsevogn Hornsherred",
    description: "Lej vores pølsevogn til alle begivenheder i Hornsherred",
    keywords: [
      "Pølsevogn", "Leje", "Lej", "Udlejning", "Pølsemand", "Skibby",
      "Jægerspris", "Kulhuse", "Kirke Hyllinge", "Ejby",
    ],
  },
  {
    slug: "lej-en-polsevogn-farum",
    title: "Lej en Pølsevogn Farum",
    description: "Lej vores pølsevogn i Faurm til alle festlige arrangementer",
    keywords: ["pølsevogn", "leje", "Farum", "udlejning", "Festudlejning", "lej"],
  },
  {
    slug: "lej-en-polsevogn-birkerod",
    title: "Lej en Pølsevogn Birkerød",
    description: "Lej vores pølsevogn i Birkerød til alle festlige lejligheder.",
    keywords: ["pølsevogn", "lej", "leje", "udlejning", "Birkerød", "Festudlejning"],
  },
  {
    slug: "lej-en-polsevogn-vaerlose",
    title: "Lej en Pølsevogn Værløse",
    description:
      "Skal du leje en pølsevogn til din fest i Værløse - så kontakt Lej en Pølsevogn Værløse",
    keywords: ["pølsevogn", "lej", "leje", "Udlejning", "Værløse", "Festudlejning"],
  },
  {
    slug: "lej-en-polsevogn-valby",
    title: "Lej en Pølsevogn Valby",
    description:
      "Lej vores pølsevogn i Valby til dit næste arrangement - fra 30 til 10.000 personer",
    keywords: ["pølsevogn", "leje", "udlejning", "Valby", "lej pølsevogn Valby"],
  },
  {
    slug: "lej-en-polsevogn-vanlose",
    title: "Lej en Pølsevogn Vanløse",
    description: "Lej vores pølsevogn i Vanløse til firmafester og privat fester",
    keywords: ["Pølsevogn", "Vanløse", "Leje", "udlejning", "Pølsemand", "Lej", "Lej pølsevogn Vanløse"],
  },
  {
    slug: "lej-en-polsevogn-bronshoj",
    title: "Lej en Pølsevogn Brønshøj",
    description: "Lej vores pølsevogn i Brønshøj til alle begivenheder",
    keywords: ["Pølsevogn", "Leje", "Brønshøj", "Udlejning", "Pølsemand"],
  },
  {
    slug: "lej-en-polsevogn-soro",
    title: "Lej en Pølsevogn Sorø",
    description: "Lej din pølsevogn i Sorø til alle typer arrangementer",
    keywords: ["Pølsevogn", "Lej", "Leje", "Sorø", "Udlejning", "Lej pølsevogn Sorø", "Pølsemand"],
  },
  {
    slug: "lej-en-polsevogn-sonderjylland",
    title: "Lej en pølsevogn Sønderjylland",
    description: "Lej vores pølsevogn i Sønderjylland til din næste fest",
    keywords: [
      "Pølsevogn", "Leje", "Udlejning", "Pølsemand", "lej", "Sønderjylland",
      "Krusaa", "Als", "Sønderborg", "Vejen", "Tønder", "Løgumkloster", "Padborg",
      "Toftlund", "Vojens", "Rødekro", "Haderslev",
    ],
  },
  {
    slug: "lej-en-polsevogn-nordjylland",
    title: "Lej en Pølsevogn Nordjylland",
    description: "Lej vores pølsevogn i Nordjylland til alle typer festlige arrangementer",
    keywords: [
      "Pølsevogn", "Leje", "Pølsemand", "Lej", "Udlejning", "Nordjylland",
      "Blokhus", "Løkken", "Sindal", "Vodskov", "Brønderslev", "Vrå", "Hjørring", "Sæby",
    ],
  },
  {
    slug: "lej-en-polsevogn-fyn",
    title: "Lej en Pølsevogn Fyn",
    description: "Pølsevogn på Fyn udlejes til alle typer arrangementer.",
    keywords: [
      "Pølsevogn", "Leje", "Udlejning", "Pølsemand", "Lej", "Ringe",
      "Munkebo", "Bogense", "Middelfart", "Søndersø", "Assens",
    ],
  },
  {
    slug: "lej-en-p-lsevogn-svendborg",
    title: "Lej en pølsevogn Svendborg",
    description: "Lej vores pølsevogn i Svendborg til dit næste festlige arrangement",
    keywords: ["Leje", "Pølsevogn", "Svendborg", "Udlejning", "Lej pølsevogn Svendborg", "Lej"],
  },
  {
    slug: "lej-en-p-lsevogn-s-nderborg",
    title: "Lej en Pølsevogn Sønderborg",
    description: "Vi udlejer vores pølsevogn i Sønderborg til alle festlige begivenheder.",
    keywords: ["Pølsevogn", "leje", "Sønderborg", "udlejning", "lej", "lej pølsevogn Sønderborg"],
  },
  {
    slug: "lej-en-p-lsevogn-haslev",
    title: "Lej en Pølsevogn Haslev",
    description:
      "Lej byens pølsevogn i Haslev til din næste fest, julefrokost, bryllup, firmafest el.lign",
    keywords: ["leje", "pølsevogn", "Haslev", "Udlejning", "Lej", "Catering", "Pølsemand"],
  },
  {
    slug: "lej-en-p-lsevogn-esperg-rde-humbleb-k",
    title: "Lej en Pølsevogn Espergærde/Humblebæk",
    description:
      "Vi udlejer vores pølsevogn i Espergærde og Humlebæk til alle typer begivenheder - store som små",
    keywords: ["Lej", "Pølsevogn", "Espergærde", "Humlebæk", "Udlejning", "Pølsemand", "lej pølsevogn"],
  },
  {
    slug: "lej-en-p-lsevogn-kors-r",
    title: "Lej en Pølsevogn Korsør",
    description:
      "Lej vores pølsevogn i Korsør til firmafesten, rejsegildet eller andet sjov begivenhed",
    keywords: ["lej", "pølsevogn", "Korsør", "udlejning", "Leje", "Pølsemand"],
  },
  {
    slug: "lej-en-p-lsevogn-p-falster",
    title: "Lej en Pølsevogn på Falster",
    description:
      "Vi udlejer vores pølsevogn på hele Falster til alle begivenheder fra 30 til 10000 personer",
    keywords: ["Lej", "Pølsevogn", "leje", "udlejning", "Falster", "Gedser", "Nykøbing F", "Pølsemand"],
  },
  {
    slug: "helsinge",
    title: "Helsinge",
    description: "Lej Pølsevogn i Helsinge: Autentisk Dansk Gadekøkken til Dit Arrangement",
    keywords: ["leje", "Pølsevogn", "Helsinge", "Udlejning"],
  },
];

// Derive a display name for a city from its old <title>.
// e.g. "Lej en Pølsevogn København" -> "København"; "Helsinge" -> "Helsinge".
export const cityFromTitle = (title) =>
  title.replace(/^Lej (?:en )?[Pp]ølsevogn\s*/u, "").trim();

export const findLocationBySlug = (slug) =>
  LOCATIONS.find((loc) => loc.slug === slug);

// A few siblings to interlink from a location page (internal links help SEO).
export const relatedLocations = (slug, count = 6) => {
  const idx = LOCATIONS.findIndex((loc) => loc.slug === slug);
  if (idx === -1) return [];
  const out = [];
  for (let i = 1; out.length < count && i <= LOCATIONS.length; i++) {
    const loc = LOCATIONS[(idx + i) % LOCATIONS.length];
    if (loc.slug !== slug) out.push(loc);
  }
  return out;
};
